import { defineMessages } from 'react-intl';

export default defineMessages({
  myServices: {
    id: 'dashboard_amc.my_services',
  },
  findDoctor: {
    id: 'dashboard_amc.find_doctor',
  },
  findAgent: {
    id: 'dashboard_amc.find_agent',
  },
});
